import Breadcrumbs from './Breadcrumbs.vue';
export default Breadcrumbs;
export type { PathItem } from './Breadcrumbs.vue';
